import "./App.css";
import Nav from "./components/Nav";
import Footer from "./components/Footer";

import Skeleton from "@mui/material/Skeleton";
import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
const Home = React.lazy(() => import("./pages/Home"));
const About = React.lazy(() => import("./pages/About"));
const Contact = React.lazy(() => import("./pages/Contact"));
const PianoLessons = React.lazy(() => import("./pages/PianoLessons"));
const PianoCampReg = React.lazy(() => import("./pages/PianoCampReg"));
const PianoCamp = React.lazy(() => import("./pages/PianoCamp"));
const Gallery = React.lazy(() => import("./pages/Gallery"));
const Events = React.lazy(() => import("./pages/Events"));

function App() {
  const routesData = [
    {
      path: "/",
      component: <Home />,
      fallback: (
        <div className="container skeleton-container">
          <div className="row">
            <div className="col-md-6">
              <Skeleton variant="text" sx={{ fontSize: "7em" }} />
              <br />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"10em"} height={"3em"} />
              <br />
              <Skeleton variant="circular" width={"3em"} height={"3em"} />
              <br />
              <br />
            </div>
            <div className="col-md-6">
              <Skeleton variant="rectangular" width={"100%"} height={"35em"} />
            </div>
          </div>
        </div>
      )
    },
    {
      path: "/about",
      component: <About />,
      fallback: (
        <div className="container skeleton-container">
          <div className="row">
            <div className="col-md-4 offset-md-4 mb-5">
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
            </div>
            <div className="col-md-6">
              <Skeleton variant="rectangular" width={"100%"} height={"35em"} />
              <br />
              <br />
            </div>
            <div className="col-md-6">
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <br />
              <br />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <br />
              <br />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <Skeleton variant="text" sx={{ fontSize: "1em" }} />
              <br />
              <br />
            </div>
          </div>
        </div>
      )
    },
    {
      path: "/contact",
      component: <Contact />,
      fallback: (
        <div className="container skeleton-container">
          <div className="row">
            <div className="col-md-4 offset-md-4 mb-5">
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
            </div>
            <div className="col-md-6">
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"10em"} height={"3em"} />
              <br />
              <br />
            </div>
            <div className="col-md-6 about-img-container">
              <Skeleton variant="rectangular" width={"100%"} height={"35em"} />
            </div>
          </div>
        </div>
      )
    },
    {
      path: "/piano-lessons",
      component: <PianoLessons />,
      fallback: (
        <div className="container skeleton-container">
          <div className="row">
            <div className="col-md-4 offset-md-4 mb-5">
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
            </div>
            <div className="col-md-6">
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"10em"} height={"3em"} />
              <br />
              <br />
            </div>
            <div className="col-md-6">
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
              <br />
              <br />
            </div>
          </div>
        </div>
      )
    },
    {
      path: "/piano-camp-signup",
      component: <PianoCampReg />,
      fallback: (
        <div className="container skeleton-container">
          <div className="row">
            <div className="col-md-4 offset-md-4 mb-5">
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
            </div>
            <div className="col-md-6">
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"10em"} height={"3em"} />
              <br />
              <br />
            </div>
            <div className="col-md-6">
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
            </div>
          </div>
        </div>
      )
    },
    {
      path: "/piano-camp",
      component: <PianoCamp />,
      fallback: (
        <div className="container skeleton-container">
          <div className="row">
            <div className="col-md-4 offset-md-4 mb-5">
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
            </div>
            <div className="col-md-12 mb-5">
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
            </div>
            <div className="col-md-6">
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"10em"} height={"3em"} />
              <br />
              <br />
            </div>
            <div className="col-md-6">
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"10em"} height={"3em"} />
              <br />
              <br />
            </div>
          </div>
        </div>
      )
    },
    {
      path: "/gallery",
      component: <Gallery />,
      fallback: (
        <div className="container skeleton-container">
          <div className="row">
            <div className="col-md-4 offset-md-4 mb-5">
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
            </div>
            <div className="clearfix"></div>
            <div className="mb-4 col-md-4">
              <Skeleton variant="rectangular" width={"100%"} height={"25em"} />
              <br />
              <br />
            </div>
            <div className="mb-4 col-md-4">
              <Skeleton variant="rectangular" width={"100%"} height={"25em"} />
              <br />
              <br />
            </div>
            <div className="mb-4 col-md-4">
              <Skeleton variant="rectangular" width={"100%"} height={"25em"} />
              <br />
              <br />
            </div>
            <div className="mb-4 col-md-4">
              <Skeleton variant="rectangular" width={"100%"} height={"25em"} />
              <br />
              <br />
            </div>
            <div className="mb-4 col-md-4">
              <Skeleton variant="rectangular" width={"100%"} height={"25em"} />
              <br />
              <br />
            </div>
            <div className="mb-4 col-md-4">
              <Skeleton variant="rectangular" width={"100%"} height={"25em"} />
              <br />
              <br />
            </div>
          </div>
        </div>
      )
    },
    {
      path: "/events",
      component: <Events />,
      fallback: (
        <div className="container skeleton-container">
          <div className="row">
            <div className="col-md-4 offset-md-4 mb-5">
              <Skeleton variant="rectangular" width={"100%"} height={"6em"} />
            </div>
            <div className="col-md-12 mb-5">
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
              <Skeleton variant="rectangular" width={"100%"} height={"3em"} />
              <br />
              <br />
            </div>
          </div>
        </div>
      )
    }
  ];
  return (
    <Router>
      <Nav />
      <Routes>
        {routesData.map((data, index) => {
          return (
            <Route
              key={index}
              path={data.path}
              element={
                <Suspense fallback={data.fallback}>{data.component}</Suspense>
              }
            />
          );
        })}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
